var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from '../EventEmitter';
var StaticTreeDataProvider = /** @class */ (function () {
    function StaticTreeDataProvider(items, setItemName
    // private implicitItemOrdering?: (itemA: TreeItem<T>, itemB: TreeItem<T>) => number,
    ) {
        /** Emit an event with the changed item ids to notify the tree view about changes. */
        this.onDidChangeTreeDataEmitter = new EventEmitter();
        this.data = { items: items };
        this.setItemName = setItemName;
    }
    StaticTreeDataProvider.prototype.getTreeItem = function (itemId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.data.items[itemId]];
            });
        });
    };
    StaticTreeDataProvider.prototype.onChangeItemChildren = function (itemId, newChildren) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.data.items[itemId].children = newChildren;
                this.onDidChangeTreeDataEmitter.emit([itemId]);
                return [2 /*return*/];
            });
        });
    };
    StaticTreeDataProvider.prototype.onDidChangeTreeData = function (listener) {
        var _this = this;
        var handlerId = this.onDidChangeTreeDataEmitter.on(function (payload) {
            return listener(payload);
        });
        return { dispose: function () { return _this.onDidChangeTreeDataEmitter.off(handlerId); } };
    };
    StaticTreeDataProvider.prototype.onRenameItem = function (item, name) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.setItemName) {
                    this.data.items[item.index] = this.setItemName(item, name);
                    // this.onDidChangeTreeDataEmitter.emit(item.index);
                }
                return [2 /*return*/];
            });
        });
    };
    return StaticTreeDataProvider;
}());
export { StaticTreeDataProvider };
